import React from 'react'
import DropzoneController from '../dropzone'
import { acceptExtensions } from '../../helper/function'
import { useFormContext } from 'react-hook-form'
import { IMAGE_MODULE } from '../../util/constant'

const UploadProperty = () => {
  const { control, watch } = useFormContext()
  return (
    <>
      <div className="form-group">
        <label>Upload Your Property Photos</label>
        <DropzoneController
          name="property_image"
          maxFiles={10}
          acceptExtensions={acceptExtensions}
          control={control}
          files={watch('property_image')}
          isEditImage={true}
          module={IMAGE_MODULE.PROPERTIES}
        />
      </div>
    </>
  )
}

export default UploadProperty
